import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getMixturesSelector = createSelector(
  mixture => mixture.mixture,
  (mixturesById) => getArrayOfObjectValues(mixturesById)
);